import { formatNumber } from '../../../../../../../helpers/numbers'

import { themeColors } from '../constants'
import { STAKEHOLDER_COUNT } from '../../fields'

// Create the main SV Theme node
export const createSVThemeNode = (layout, themes) => {
  const { xThemeBase, leftPillW, yPositions } = layout

  // Calculate vertical center position based on actual row positions
  const firstRowY = yPositions[0]
  const lastRowY = yPositions[yPositions.length - 1]
  const centerY = (firstRowY + lastRowY) / 2

  return {
    id: 'left',
    x: xThemeBase,
    y: centerY,
    w: leftPillW,
    h: 19,
    label: 'SV Theme',
    fill: '#111111',
    textColor: '#fff'
  }
}

// Create all theme, social criteria, and impact nodes
export const createThemeNodes = (themes, layout, formatCurrency) => {
  const { xTheme, xOutcome, xImpact, pillW, pillH, yPositions } = layout
  const nodes = []

  themes.forEach((t, i) => {
    const color = themeColors[i % themeColors.length]
    const y = yPositions[i] // Use dynamic Y position from layout

    const themeNode = {
      id: `theme-${i}`,
      x: xTheme,
      y,
      w: pillW,
      h: pillH,
      label: t.theme_name,
      fill: color.bar
    }

    // Convert social_criteria string to title case
    // Regex /(^.|\s.)/g matches: ^. (first character) and \s. (character after space)
    const outcomeLabel = (t.social_criteria || '').replace(/(^.|\s.)/g, c => c.toUpperCase())

    const outcomeNode = {
      id: `out-${i}`,
      x: xOutcome,
      y,
      w: pillW,
      h: pillH,
      label: outcomeLabel,
      fill: color.bar
    }

    const impactNode = {
      id: `imp-${i}`,
      x: xImpact,
      y,
      w: pillW,
      h: pillH,
      label: formatCurrency(t.total_impact),
      secondaryLabel: `${formatNumber(t[STAKEHOLDER_COUNT])} stakeholders`,
      fill: color.bar
    }

    nodes.push(themeNode, outcomeNode, impactNode)
  })

  return nodes
}

// Create all connection links
export const createLinks = (themes, svThemeNode, nodes) => {
  const links = []

  themes.forEach((t, i) => {
    const color = themeColors[i % themeColors.length]
    const themeNode = nodes.find(n => n.id === `theme-${i}`)
    const outcomeNode = nodes.find(n => n.id === `out-${i}`)
    const impactNode = nodes.find(n => n.id === `imp-${i}`)

    links.push({ from: svThemeNode, to: themeNode, color: color.link, value: t.total_impact })
    links.push({ from: themeNode, to: outcomeNode, color: color.link, value: t.total_impact })
    links.push({ from: outcomeNode, to: impactNode, color: color.link, value: t.total_impact })
  })

  return links
}
